import React, { useId } from 'react';
interface PhoneInputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  id?: string;
}
/**
 * Standardized Maybank phone input.
 * Fixed +60 (Malaysia) prefix on the left, numeric input on the right.
 */
export function PhoneInput({
  label = 'Mobile number',
  value,
  onChange,
  error,
  helperText,
  placeholder = '12 345 6789',
  required,
  disabled,
  autoFocus,
  maxLength = 10,
  id
}: PhoneInputProps) {
  const reactId = useId();
  const inputId = id || `phone-${reactId}`;
  const helperId = helperText ? `${inputId}-help` : undefined;
  const errorId = error ? `${inputId}-err` : undefined;
  const describedBy = [errorId, helperId].filter(Boolean).join(' ') || undefined;
  return <div className="w-full" data-id="element-1001">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-900 mb-1.5" data-id="element-1002">
          {label}
          {required && <span className="text-red-600 ml-0.5" aria-hidden="true" data-id="element-1003">
              *
            </span>}
          {required && <span className="sr-only" data-id="element-1004"> (required)</span>}
        </label>}
      <div className={`flex items-stretch min-h-[44px] rounded-lg border-2 shadow-sm overflow-hidden bg-white
          focus-within:ring-2 focus-within:ring-[#B8860B] focus-within:ring-offset-1 focus-within:border-[#B8860B] transition-all
          ${error ? 'border-red-600' : 'border-gray-500'}
          ${disabled ? 'bg-gray-100' : ''}`} data-id="element-1005">
        <div className="flex items-center gap-1.5 px-3 bg-gray-100 border-r-2 border-gray-500 text-gray-900 font-semibold text-sm select-none" aria-hidden="true" data-id="element-1006">
          <span data-id="element-1007">🇲🇾</span>
          <span data-id="element-1008">+60</span>
        </div>
        <span className="sr-only" data-id="element-1009">Malaysian dialing code +60</span>
        <input id={inputId} type="tel" inputMode="numeric" aria-invalid={error ? true : undefined} aria-describedby={describedBy} value={value} onChange={e =>
      // Strip non-digits, then strip a leading 0 (Malaysian numbers
      // shouldn't be entered with a 0 after the +60 prefix).
      onChange(e.target.value.replace(/\D/g, '').replace(/^0+/, ''))} placeholder={placeholder} disabled={disabled} autoFocus={autoFocus} maxLength={maxLength} className="flex-1 border-0 bg-transparent py-3 px-3 text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 disabled:text-gray-600" data-id="element-1010" />
      </div>
      {helperText && !error && <p id={helperId} className="mt-1 text-xs text-gray-600" data-id="element-1011">
          {helperText}
        </p>}
      {error && <p id={errorId} className="mt-1 text-sm text-red-700 font-medium" role="alert" data-id="element-1012">
          {error}
        </p>}
    </div>;
}